<span [hidden]="!loading"> <ab-spinner-inline></ab-spinner-inline></span>
<div class="integration-error" *ngIf="error">
  <b>{{ error.error }}:&nbsp;</b>{{ error.errorMessage }}.<br /><a
    href="/projects/{{ notice.projectId }}/services/10"
    target="_self"
    >Check your settings</a
  >
</div>
<button
  class="btn btn-holder"
  *ngIf="!issue?.url && !error && !loading"
  (click)="createIssue()"
  [disabled]="creatingIssue"
  type="button"
>
  <span *ngIf="!creatingIssue"
    ><i
      class="glyphicon glyphicon-ab-integrations-github glyphicon--valign-baseline"
    ></i
    >&nbsp;<span>Create GitHub&nbsp;</span
    ><span *ngIf="fields.host">Enterprise&nbsp;</span>issue</span
  ><span [hidden]="!creatingIssue">
    <ab-spinner-inline></ab-spinner-inline><span>Creating GitHub&nbsp;</span
    ><span *ngIf="fields.host">Enterprise&nbsp;</span>issue</span
  >
</button>
<div *ngIf="issue?.url">
  <i
    class="glyphicon glyphicon-ab-integrations-github glyphicon--valign-baseline"
  ></i
  >&nbsp;<ab-external-link *ngIf="issue.url" href="{{ issue.url }}"
    >View on GitHub<span *ngIf="fields.host"
      >&nbsp;Enterprise</span
    ></ab-external-link
  >&nbsp;
  <button
    class="btn btn-holder btn--reduced-padding"
    *ngIf="issue.url && !error"
    (click)="removeIssue()"
    [disabled]="removingIssue"
    type="button"
  >
    <span *ngIf="!removingIssue">Remove</span
    ><span [hidden]="!removingIssue">
      <ab-spinner-inline></ab-spinner-inline>Removing</span
    >
  </button>
</div>
